<template>
	<div class="on_sale_table">
		<div class="table" >
			<el-table ref="multipleTable" :height="590" :border="false" :data="tableData" tooltip-effect="dark"
				style="font-size: 0.75rem;" @selection-change="handleSelectionChange">
				<el-table-column align="center" type="selection" label="">
				</el-table-column>
				<el-table-column align="center" prop="number" label="客户编号" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="company" label="公司名称" show-overflow-tooltip>
				</el-table-column>
				<!-- <el-table-column align="center" prop="work_phone" label="公司电话" show-overflow-tooltip> -->
				</el-table-column>
				<el-table-column align="center" prop="company_address" label="公司地址" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="name"  label="客户姓名" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="job"  label="职务" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="micro_number"  label="联系方式" show-overflow-tooltip>
				</el-table-column>
				<!-- <el-table-column align="center" prop="micro_number2"  label="联系方式二" show-overflow-tooltip> -->
				</el-table-column>
				<el-table-column align="center" prop="email"  label="备注" show-overflow-tooltip>
				</el-table-column>
				<!-- <el-table-column align="center" prop="is_confirm" label="禁用" width="90">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.is_confirm" @change="switchChange(scope.row)" active-color="#1E69FF" inactive-color="#B5CBF9">
						</el-switch>
					</template>
				</el-table-column> -->
				<el-table-column align="center" prop="address" label="操作"  width="180">
					<template slot-scope="scope">
						<el-button size="mini"
							style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="openDetail(scope.$index, scope.row)">查看</el-button>
						<!-- <el-button size="mini"
							style="background: #FF9D1F;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
						<i class="el-icon-delete" style="margin-left: 10px;cursor: pointer;font-size: 1.3rem;"
							@click="handleDelete(scope.$index, scope.row)"></i>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<footer class="d-flex j-sb a-center">
			<div class="d-flex a-center">
				<div @click="batchDelshelves" style="cursor: pointer; width: 5.63rem; height: 1.25rem;line-height: 1.25rem;text-align: center; font-size: 0.75rem;font-weight: bold;border: 2px solid #000000;border-radius: 0.625rem;">
					批量删除
				</div>
				<div @click="pushCard" 
				style="cursor: pointer; width: 5.63rem; height: 1.25rem;line-height: 1.25rem;margin-left: 20px;
				text-align: center; font-size: 0.75rem;font-weight: bold;border: 2px solid #000000;border-radius: 0.625rem;">
					推送名片
				</div>
			</div>
			
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, total" :total="total_records">
			</el-pagination>
		</footer>
		<el-dialog
		  :visible.sync="showCard"
		  width="1170px"
		  center>
		  <div style="display: flex;align-items: center;justify-content: center;position: relative;" slot="title">
				<div>选择接收名片的员工</div>
				<div style="position: absolute;right: 100px;">
					<el-input v-model="keywords" size="small" style="width: 300px;" placeholder="请输入搜索关键字" class="input-with-select">
						<el-button @click="staff_card_list" slot="append" icon="el-icon-search"></el-button>
					</el-input>
				</div>
		  </div>
		  <div style="padding: 0 20px 20px 20px;background: #F8F8F8;height: 560px;overflow-y: scroll;">
			  <el-checkbox-group v-model="checkList">
				  <label v-for="(item,index) in tableDatas" :key="index" 
				  style="display: flex;height: 50px;align-items: center;font-size: 12px;cursor: pointer;justify-content: space-between;">
					<el-checkbox :label="item.id"><br></el-checkbox>
					<div style="width: 60px;text-align: center;width: 16%;">{{item.number}}</div>
					<div class="text-hide-2" style="width: 16%;">{{item.company}}</div>
					<div class="text-hide-2" style="width: 16%;">{{item.work_phone}}</div>
					<div class="text-hide-2" style="width: 16%;">{{item.name}}</div>
					<div class="text-hide-2" style="width: 16%;">{{item.job}}</div>
					<div class="text-hide-2" style="width: 16%;">{{item.micro_number}}</div>
				  </label>
			  </el-checkbox-group>
		  </div>
		  <div class="d-flex a-center j-center" style="margin-top: 20px;">
				<div @click="showCard=false" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #cccccc;
				border-radius: 4px;display: flex;align-items: center;justify-content: center;">
					取消
				</div>
				<div @click="staff_forward()" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #1E69FF;
				border-radius: 4px;display: flex;align-items: center;justify-content: center;margin-left: 30px;">
					确定转发
				</div>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props:{
			keyword: {
                type: String,
                default: null
            }
		},
		data(){
			return {
				currentPage: 1, //初始页
				pageSize : 10,
				tableData: [],
				total_records : 0,
				goods_ids : [],
				status : '',
				goods_id : '',
				showCard:false,
				checkList:[],
				tableDatas:[],
				keywords:''
			}
		},
		methods: {
			pushCard(){
				if(this.goods_ids.length == 0){
					this.$message({
						showClose: false,
						message: '至少选择一个客户进行推送',
						type: 'error',
						offset: 350
					})
					return
				}
				this.showCard = true
				
			},
			staff_forward(){
				if(this.checkList.length==0){
					this.$message({
						showClose: false,
						message: '请选择推送员工',
						type: 'error',
						offset: 350
					})
					return
				}
				let param = {
					act : 'staff_forward',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					type : 0,
					staff_ids : this.goods_ids.join(','),
					receive_staff_ids : this.checkList.join(','),
				}
				this.$api.staff_card_list(param).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '推送成功',
							type: 'success',
							offset: 350
						})
						this.showCard = false
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			getOnsalegoods(){
				let param = {
					act : 'staff_card_customer_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					status : 1,
					keyword : this.keyword,
					page : this.currentPage,
					size : this.pageSize
				}
				this.$api.staff_card_list(param).then((res)=>{
					this.tableData = []
					if(res.code == 0){
						res.data.forEach((item) => {
							this.tableData.push({...item,is_confirm:item.status==1?true:false})
						})
						this.total_records = parseInt(res.total_records)
					}
				})
			},
			staff_card_list(){
				let param = {
					act : 'staff_card_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					status : 1,
					keyword : this.keywords,
					page : 1,
					size : 99
				}
				this.$api.staff_card_list(param).then((res)=>{
					this.tableDatas = []
					if(res.code == 0){
						res.data.forEach((item) => {
							this.tableDatas.push({...item,is_confirm:item.status==1?true:false})
						})
					}
				})
			},
			onoffGoods(status){
				let param = {
					act : status,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ids : this.goods_ids.join(',')
				}
				this.$api.staff_card_show(param).then((res)=>{
					if(res.code == 0){
						this.$message.success(res.msg)
						this.goods_ids = []
						this.getOnsalegoods()
					}else{
						this.$message.error('操作失败')
					}
				})
			},
			delGoods(){
				let param = {
					act : 'staff_card_customer_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					collect_ids : this.goods_ids.join(',')
				}
				this.$api.staff_card_del(param).then((res)=>{
					if(res.code == 0){
						this.$message.success(res.msg)
						this.getOnsalegoods()
					}else{
						this.$message.error('操作失败')
					}
				})
			},
			switchChange(item){
				if(item.is_confirm == false){
					let status = 'staff_card_off'
					this.goods_ids = [item.id]
					this.onoffGoods(status)
				}else{
					let status = 'staff_card_show'
					this.goods_ids = [item.id]
					this.onoffGoods(status)
				}
			},
			batchOffshelves(){
				if(this.goods_ids.length == 0){
					this.$message.warning('请至少选择一个商品')
				}else{
					let status = 'enterprise_goods_off'
					this.onoffGoods(status)
				}
			},
			batchDelshelves(){
				if(this.goods_ids.length == 0){
					this.$message.warning('请至少选择一个数据')
				}else{
					this.$msgbox.confirm('是否确认此操作?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.delGoods()
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});  
					})
				}
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getOnsalegoods()
			},
			handleSelectionChange(val) {
				let goodsId = []
				val.forEach((item) => {
					goodsId.push(item.id)
				})
				this.goods_ids = goodsId
				// this.checkList = goodsId
			},
			handleEdit(index, row) {
				row.editStatus = false
				row.editState = 0
				this.$router.push({path:'addCard',query:{...row,state:2}})
			},
			handleDelete(index, row){
				this.$msgbox.confirm('是否确认此操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.goods_ids.push(row.id)
					this.delGoods()
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});  
				})
			},
			openDetail(index, row){
				row.editStatus = true
				row.editState = 1
				this.$router.push({path:'addCard',query:{...row,state:1}})
			}
		},
		mounted() {
			this.getOnsalegoods()
			this.staff_card_list()
			this.$nextTick(function() {
				this.$on('childmethods',function(){
					let param = {
						act : 'staff_card_list',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						status : 1,
						keyword : this.keyword,
						page : this.currentPage,
						size : this.pageSize
					}
					this.$api.login(param).then((res)=>{
						this.tableData = []
						if(res.code == 0){
							res.data.forEach((item) => {
								this.tableData.push({...item,is_confirm:item.status==1?true:false})
							})
							this.total_records = parseInt(res.total_records)
						}
					})
				});
			});
		}
	}
</script>

<style lang="scss" scoped>
	.suojin{
		text-overflow: ellipsis;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.on_sale_table{
		.table {
			margin-top: 1.44rem;
			width: 100%;
			background: #FFFFFF;
			border-radius: 6px;
			overflow: hidden;
		}		
		footer {
			width: 100%;
			height: 3.85rem;
			background: #FFFFFF;
			margin-top: 1.44rem;
			border-radius: 6px;
			padding: 0 1.25rem;
			box-sizing: border-box;
		}
	}
</style>
